import { render, staticRenderFns } from "./layout-options.vue?vue&type=template&id=050778a0&"
import script from "./layout-options.vue?vue&type=script&lang=js&"
export * from "./layout-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "layout-options.vue"
export default component.exports